import { BitkitNativeSelect } from '@bitrise/bitkit-v2';
import { AriaAttributes, ChangeEvent, Fragment, useCallback } from 'react';

import { DataTableHeader, DataTableSort } from '../types/DataTable.type';

type DataTableSortMobileProps = { headers: DataTableHeader[]; sort: DataTableSort };

const DataTableSortMobile = ({ headers, sort }: DataTableSortMobileProps) => {
  const onChange = useCallback(
    (event: ChangeEvent<HTMLSelectElement>) => {
      const [part1, part2] = event.target.value.split('-') as [string, AriaAttributes['aria-sort']];

      sort.onSortClick(part1, part2);
    },
    [sort],
  );

  const valueFromKeyAndDirection = useCallback((key: string, direction: AriaAttributes['aria-sort']) => {
    return `${key}-${direction}`;
  }, []);

  return (
    <BitkitNativeSelect
      value={valueFromKeyAndDirection(sort.sortHeader, sort.sortDirection)}
      onChange={onChange}
      placeholder="Sort"
      label="Sort"
      labelHidden
      optional
      marginBlockEnd="16"
    >
      <option value={valueFromKeyAndDirection(sort.sortHeader, 'none')}>Not sorted</option>
      {headers.map(({ key, label: headerLabel, sortDirectionLabels }) => {
        if (!headerLabel) {
          return;
        }

        return (
          <Fragment key={key}>
            <option value={valueFromKeyAndDirection(key, 'ascending')}>
              {headerLabel} ({sortDirectionLabels?.ascending || 'ascending'})
            </option>
            <option value={valueFromKeyAndDirection(key, 'descending')}>
              {headerLabel} ({sortDirectionLabels?.descending || 'descending'})
            </option>
          </Fragment>
        );
      })}
    </BitkitNativeSelect>
  );
};

export default DataTableSortMobile;
